import React from 'react';
import type { HeadType } from '@atlaskit/dynamic-table/types';
import {
	ACTIONS,
	NAME,
	RELATED_SCHEMES,
	HIERARCHY_LEVEL,
} from '@atlassian/jira-admin-pages-issue-types-common/src/constants.tsx';
import type { HeadingCellWrapper as HeadingCellWrapperType } from '@atlassian/jira-admin-pages-issue-types-common/src/ui/index.tsx';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import { messages } from './messages';

export const getTableHead = (
	HeadingCellWrapper: typeof HeadingCellWrapperType,
	formatMessage: FormatMessage,
): HeadType => ({
	cells: [
		{
			key: NAME,
			isSortable: true,
			content: <HeadingCellWrapper first>{formatMessage(messages.name)}</HeadingCellWrapper>,
			width: 40,
		},
		{
			key: HIERARCHY_LEVEL,
			isSortable: true,
			content: <HeadingCellWrapper>{formatMessage(messages.hierarchyLevel)}</HeadingCellWrapper>,
			width: 15,
		},
		{
			key: RELATED_SCHEMES,
			content: <HeadingCellWrapper>{formatMessage(messages.relatedSchemes)}</HeadingCellWrapper>,
			width: 40,
		},
		{
			key: ACTIONS,
		},
	],
});
